import { BaseSliceController } from '@Base/slices/slices.base';
import { PromoCodesRequester } from '../Services/PromoCodes.req';
import { PromoCode } from '../Types/PromoCodes.types';

export class PromoCodesSlice extends BaseSliceController<
	PromoCode,
	'PromoCodes'
> {
	private static instance: PromoCodesSlice;
	static getInstance() {
		if (!PromoCodesSlice.instance) {
			PromoCodesSlice.instance = new PromoCodesSlice();
		}
		return PromoCodesSlice.instance;
	}
	constructor() {
		super('PromoCodes', PromoCodesRequester.getInstance());
	}
}

export const {
	promoCodesDeleteById,
	promoCodesCreate,
	promoCodesUpdate,
	promoCodesGetAll,
	promoCodesGetSingle,
} = PromoCodesSlice.getInstance().getActions();
